import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { MdAdd } from 'react-icons/md';

const DashboardItem = ({
  itemsList = [], title, shouldShowAddBtn = true, shouldShowDropdown = true, dropdownOptions = [], type, onSortChange = () => {}, onClickAddButton = () => {},
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDropdownChange = (event) => {
    const selectedOption = event.target.value;
    onSortChange(selectedOption);
  };

  return (
    <div className={`h-full w-full flex flex-col justify-between m-0 py-[0.875rem] px-[1.438rem] rounded-md bg-vamos-white shadow-vamos-drop-shadow overflow-visible ${type}`}>
      <div>
        <header className="flex items-center relative mb-4 shrink-0">
          <h2 className="text-2xl font-bold ml-2.5">{title}</h2>
          {shouldShowAddBtn && <button type="button" className="absolute right-0 flex justify-center items-center w-6 h-6 bg-vamos-black rounded-full border-0 p-0 hover:bg-vamos-green1 focus:outline-none" onClick={onClickAddButton}> <MdAdd size={20} color="#FCFCFC" /></button>}
        </header>
        {shouldShowDropdown
          && (
          <select
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            onBlur={() => setIsDropdownOpen(false)}
            onChange={handleDropdownChange}
            className={`flex-shrink-0 mb-3 border-none rounded-[6px] bg-vamos-v-light-gray text-sm font-normal pl-3 pr-8 w-33.75 h-9 appearance-none bg-no-repeat bg-[length:1.5rem] focus:outline-none ${isDropdownOpen ? 'bg-arrow-up' : 'bg-arrow-down'}`}
            style={{
              backgroundPosition: 'right 0.75rem center',
            }}
          >
            {dropdownOptions.map(option => <option key={option} className="bg-white active:bg-vamos-green1">{option}</option>)}
          </select>
          )}
        {itemsList.slice(0, 5)}
      </div>

      {['sites', 'notes', 'routes', 'visits'].includes(type) && (
        <div className="flex justify-end mt-2 mb-1">
          <a
            href={`/${type}`}
            className="underline font-semibold cursor-pointer hover:underline"
          >
            {`All ${title.toLowerCase()}`}
          </a>
        </div>
      )}
    </div>
  );
};

export default DashboardItem;

DashboardItem.propTypes = {
  itemsList: PropTypes.array,
  title: PropTypes.string.isRequired,
  shouldShowAddBtn: PropTypes.bool,
  shouldShowDropdown: PropTypes.bool,
  dropdownOptions: PropTypes.array,
  type: PropTypes.string.isRequired,
  onSortChange: PropTypes.func,
  onClickAddButton: PropTypes.func,
};
